import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './App.css';
import './styles/theme.css';
import 'react-toastify/dist/ReactToastify.css';
import './styles/toastify-theme.css';
import './styles/modals.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './apis/store/store';
import { Provider } from 'react-redux';
import 'boxicons/css/boxicons.min.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/nmmSetups/EFFN/Frontend/firebase-messaging-sw.js')
    .then(() => {})
    .catch((error) => {
      console.error('Service Worker registration failed:', error);
    });
}

root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function to
// reportWebVitals or send metrics to an analytics endpoint. See https://bit.ly/CRA-vitals
reportWebVitals();